const features = [
  {
    title: '暑期档爆款合集',
    desc: '《藏海花》《长相思第二季》《孤舟》等年度期待剧集正在热播，口碑炸裂，追剧党不容错过的高分好剧一网打尽。每天更新最新集数，全网同步首发。',
    tag: '热播中',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20drama%20scene%20with%20ancient%20architecture%2C%20misty%20mountains%2C%20warm%20golden%20sunset%20lighting%2C%20cinematic%20widescreen%20composition%2C%20dramatic%20atmosphere%2C%20film%20poster%20aesthetic%2C%20rich%20warm%20amber%20and%20deep%20red%20tones%2C%20epic%20scale&width=1200&height=600&seq=carousel-1&orientation=landscape',
  },
  {
    title: '高分悬疑剧场',
    desc: '《唐朝诡事录之西行》《看不见影子的少年》《九部的检察官》等高能悬疑力作，烧脑剧情全程高能，每一部都让人欲罢不能。',
    tag: '高分推荐',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20noir%20scene%20with%20shadowy%20alley%2C%20dim%20street%20lamp%2C%20rain%20soaked%20pavement%2C%20suspenseful%20atmosphere%2C%20warm%20tungsten%20and%20deep%20shadow%20contrast%2C%20cinematic%20film%20noir%20style%2C%20rich%20textured%20composition&width=1200&height=600&seq=carousel-2&orientation=landscape',
  },
  {
    title: '院线新片首发',
    desc: '《飞驰人生2》《热辣滚烫》《第二十条》等票房口碑双丰收的院线大片，高清画质全网首发上线，在家也能享受影院级观影体验。',
    tag: '最新上线',
    image: 'https://readdy.ai/api/search-image?query=Modern%20movie%20theater%20interior%20with%20large%20bright%20screen%2C%20comfortable%20red%20seats%2C%20warm%20ambient%20lighting%2C%20blockbuster%20premiere%20atmosphere%2C%20cinematic%20wide%20angle%2C%20rich%20warm%20color%20grading%2C%20premium%20cinema%20experience&width=1200&height=600&seq=carousel-3&orientation=landscape',
  },
  {
    title: '综艺欢乐季',
    desc: '《奔跑吧》《歌手2024》《乘风2024》等王牌综艺火爆来袭，搞笑名场面、实力舞台表演轮番上演，周末解压必看。',
    tag: '火爆综艺',
    image: 'https://readdy.ai/api/search-image?query=Exciting%20TV%20variety%20show%20stage%20with%20colorful%20spotlights%2C%20energetic%20performance%20atmosphere%2C%20cheering%20crowd%20silhouettes%2C%20vibrant%20warm%20stage%20lighting%2C%20entertainment%20show%20production%2C%20dynamic%20wide%20composition&width=1200&height=600&seq=carousel-4&orientation=landscape',
  },
  {
    title: '经典重温专区',
    desc: '《甄嬛传》《琅琊榜》《武林外传》等百看不厌的经典神作永久收录，高清修复画质，随时重温那些年我们一起追过的剧。',
    tag: '经典永恒',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%20beam%2C%20classic%20movie%20posters%20on%20brick%20wall%2C%20nostalgic%20cinema%20atmosphere%2C%20soft%20dust%20particles%20in%20light%2C%20warm%20sepia%20and%20golden%20tones%2C%20retro%20theater%20aesthetic&width=1200&height=600&seq=carousel-5&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">热门专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精心策划的影视专题合集，按类型、热度、口碑为你精选优质片单，找片不迷路
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer flex flex-col lg:flex-row"
            >
              <div className="relative w-full lg:w-[420px] flex-shrink-0 h-56 lg:h-auto overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-3">{item.title}</h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-primary-600 text-sm font-medium cursor-pointer">
                  <span>查看全部</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}